import React, { useState } from "react";
import { LineupTab } from "./components/LineupTab/lineup-tab";
import { lineup } from "../../../../assets/data/lineup";
import { guests, hosts } from "../../../../assets/data/people";
import "./styles.scss";

const fetchDayEvents = (day: number) =>
  lineup.filter((event) => event.day === day);

const fetchEventsGuests = (day: number) => {
  const people = [...guests, ...(Array.isArray(hosts) ? hosts : [hosts])];
  return fetchDayEvents(day)
    .flatMap((event) => event.guests)
    .map((guestId) => people.find((guest) => guest.id === guestId))
    .map((guest) => ({
      id: guest?.id,
      name: guest?.name,
      title: guest?.title,
      image: guest?.image,
      organization: guest?.organization,
    }));
};

export const Lineup = (): JSX.Element => {
  const [expandTabs, setExpandTabs] = useState(false);

  return (
    <div className="lineup">
      <div className="lineup-wrapper">
        <h1>Lineup</h1>
        <div className="lineup-controls">
          <div className="lineup-collapse">
            <button type="button" onClick={() => setExpandTabs(!expandTabs)}>
              <p>{expandTabs ? "Collapse" : "Expand"} lineup</p>
            </button>
          </div>
        </div>
        <div className="lt-wrapper">
          <LineupTab
            isExpanded={expandTabs}
            events={fetchDayEvents(1)}
            people={fetchEventsGuests(1)}
            label="Saturday, May 15"
          />
          <LineupTab
            isExpanded={expandTabs}
            events={fetchDayEvents(2)}
            label="Sunday, May 16"
            people={fetchEventsGuests(2)}
          />
        </div>
      </div>
    </div>
  );
};
